export default __webpack_public_path__ + "static/media/img-gt-mode-gt-bg-at_de@2x.a9e208fb.jpg";